import React from "react";
import Logo from "@/components/brand/Logo";
import Spark from "@/components/brand/Spark";
import { Linkedin, Instagram, Mail } from "lucide-react";

const nav = [
  { id: "services", label: "Services" },
  { id: "framework", label: "POP\u2122 Intelligence" },
  { id: "lead-magnet", label: "Sample Brief" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el)
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 70,
        behavior: "smooth",
      });
  };

  return (
    <footer
      className="bg-[#2A2422] text-[#F3EFE7] pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo tone="linen" />
            <p className="mt-6 font-body text-[#F3EFE7]/70 text-sm leading-relaxed max-w-md">
              Clarity Ignites Momentum. The Intelligence Department for Creative Small
              Businesses, Creators &amp; Solopreneurs.
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a
                href="mailto:marjorie@boommgroup.com"
                className="inline-flex items-center gap-2 text-[#F3EFE7]/80 hover:text-[#B58B42] text-sm font-body"
                data-testid="footer-email"
              >
                <Mail size={16} />
                marjorie@boommgroup.com
              </a>
            </div>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-9 h-9 rounded-[2px] border border-[#F3EFE7]/15 inline-flex items-center justify-center hover:border-[#B58B42] hover:text-[#B58B42] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 rounded-[2px] border border-[#F3EFE7]/15 inline-flex items-center justify-center hover:border-[#B58B42] hover:text-[#B58B42] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-[#B58B42]">Explore</p>
            <ul className="mt-4 space-y-3">
              {nav.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => scrollTo(n.id)}
                    className="font-body text-[#F3EFE7]/80 hover:text-[#B58B42] text-sm transition-colors"
                    data-testid={`footer-link-${n.id}`}
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-[#B58B42]">The Idea</p>
            <p className="mt-4 font-display text-2xl text-[#F3EFE7] leading-snug">
              Turning complexity into clearer next steps.
            </p>
            <div className="mt-4 flex items-center gap-3 text-[#F3EFE7]/55 font-body text-xs tracking-[0.18em] uppercase">
              <Spark size={14} />
              Intelligent &middot; Strategic &middot; Evidence-Informed
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F3EFE7]/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-body text-xs text-[#F3EFE7]/55 tracking-wide">
            &copy; {new Date().getFullYear()} BOOMM Group. All rights reserved.
          </p>
          <p className="font-body text-xs text-[#F3EFE7]/45 tracking-[0.2em] uppercase">
            Clarity Ignites Momentum.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
